exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuSelectGraph{height:100%;position:fixed;background:#fff;padding:15px;z-index:65;top:0;right:0;overflow:scroll;border-radius:0 0 0 0!important;border-left:3px solid #dbdbdb}@media screen and (max-width:768px){.menuSelectGraph{width:100%}}@media screen and (min-width:1280px){.menuSelectGraph{width:25%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25eb71b1","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frpm/components/menuGraphsDemo.vue
// module id = 2123
// module chunks = 2